/**
 * Le message d'erreur du serveur, quelle que soit la forme du corps de la réponse.
 *
 * <p>Le serveur en emploie QUATRE : une chaîne nue (16 contrôleurs), `{message}` (ApiResponse et
 * plusieurs contrôleurs), `{error}` (référentiels), et parfois rien du tout. Chaque composant
 * décodait à sa façon : celui qui lisait `data.message` face à une chaîne nue affichait
 * « Request failed with status code 400 » à l'opérateur, qui ne pouvait pas savoir quoi corriger.
 * Constaté le 2026-09-22 sur l'ajout d'un client à facturer.
 *
 * <p>Accepter les quatre formes plutôt qu'en imposer une : le lecteur peut ainsi être déployé
 * AVANT que le serveur ne soit unifié, sans rien casser au passage.
 */

/** Une réponse d'erreur HTML (page d'un proxy, du navigateur) n'est pas un message pour l'humain. */
const estUnePageWeb = (texte: string): boolean =>
    texte.startsWith('<') || texte.toLowerCase().includes('<!doctype');

/** Au-delà, ce n'est plus une phrase : trace d'exécution ou page entière. */
const LONGUEUR_MAX = 300;

const texteUtile = (valeur: unknown): string | null => {
    if (typeof valeur !== 'string') {
        return null;
    }
    const propre = valeur.trim();
    if (!propre || propre.length > LONGUEUR_MAX || estUnePageWeb(propre)) {
        return null;
    }
    return propre;
};

/**
 * @param err l'erreur remontée par axios (ou n'importe quoi d'autre)
 * @param repli ce qu'on affiche quand le serveur n'a rien dit d'exploitable — toujours en
 *              français, et jamais le message technique d'axios
 */
export const messageErreur = (err: any, repli: string): string => {
    const corps = err?.response?.data;

    const direct = texteUtile(corps);
    if (direct) {
        return direct;
    }

    if (corps && typeof corps === 'object') {
        // `message` avant `error` : ApiResponse et la plupart des contrôleurs emploient le premier.
        const porte = texteUtile(corps.message) ?? texteUtile(corps.error);
        if (porte) {
            return porte;
        }
    }

    return repli;
};
